import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
// import axios from 'axios';
//引入elementui
import 'element-ui/lib/theme-chalk/index.css';
import './assets/global.css'
Vue.config.productionTip = false
// Vue.prototype.$axios = axios
//在vue中使用elementui
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
